import React from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
const TestimonialCard = ({
  name,
  text,
  time
}: {
  name: string;
  text: string;
  time: string;
}) => <div className="bg-[#075E54] p-4 rounded-lg rounded-tl-none shadow-md max-w-sm mx-auto w-full relative" data-id="element-173">
    <div className="absolute -top-2 -left-2 w-4 h-4 bg-[#075E54] [clip-path:polygon(100%_0,0_0,100%_100%)]" data-id="element-174"></div>
    <div className="flex justify-between items-baseline mb-1" data-id="element-175">
      <span className="font-bold text-[#E1FFC7] text-sm" data-id="element-176">
        {'Seguridad y Control'}
      </span>
      <span className="text-[10px] text-gray-300" data-id="element-177">
        {'Indicadores claros (sensaciones y se\xF1ales) para ajustar intensidad y evitar sobreentrenamiento.'}
      </span>
    </div>
    <p className="text-white text-sm leading-relaxed" data-id="element-178">{text}</p>
    <div className="flex justify-end mt-1" data-id="element-179">
      <div className="flex gap-0.5" data-id="element-180">
        {[1, 2, 3, 4, 5].map(i => <Star key={i} size={10} className="fill-[#FFD700] text-[#FFD700]" data-id="element-181" />)}
      </div>
    </div>
  </div>;
export function TestimonialsSection() {
  return <Section background="darker" data-id="element-182">
      <div className="text-center mb-12" data-id="element-183">
        <h2 className="text-2xl md:text-3xl font-bold text-[#22C55E] uppercase mb-4" data-id="element-184">
          MILES DE HOMBRES YA EXPERIMENTAN EL CAMBIO VARAMAX
        </h2>
        <div className="flex justify-center gap-1 mb-2" data-id="element-185">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="fill-[#FFD700] text-[#FFD700] w-6 h-6" data-id="element-186" />)}
        </div>
        <p className="text-gray-400" data-id="element-187">
          Calificación promedio 4.9/5 basada en +1,200 clientes
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-188">
        <div className="bg-[#071F12] p-8 rounded-2xl border border-[#22C55E]/25 flex justify-center" data-id="element-189">
          <div style={{
          width: '260px',
          maxWidth: '85vw',
          overflow: 'hidden'
        }} data-id="element-190">
            <div style={{
            display: 'flex',
            animation: 'slideStep 9s infinite'
          }} data-id="element-191">
              {['https://i.ibb.co/h1VZb1Zm/img-0136-1.webp', 'https://i.ibb.co/Kp9rBJqM/img-0136-2.webp', 'https://i.ibb.co/tMvYKh3d/img-0136-3.webp', 'https://i.ibb.co/h1VZb1Zm/img-0136-1.webp' // duplicado loop
            ].map((src, i) => <div key={i} style={{
              flex: '0 0 100%'
            }} data-id="element-192">
                  <img src={src} alt="Testimonio" style={{
                width: '100%',
                height: 'auto',
                borderRadius: '18px',
                display: 'block',
                objectFit: 'cover',
                boxShadow: '0 18px 40px rgba(0,0,0,.5)'
              }} data-id="element-193" />
                </div>)}
            </div>
          </div>

          <style data-id="element-194">{`
    @keyframes slideStep {

      /* Imagen 1 pausa */
      0%, 28%   { transform: translateX(0%); }

      /* Transición */
      33%       { transform: translateX(-100%); }

      /* Imagen 2 pausa */
      33%, 61%  { transform: translateX(-100%); }

      /* Transición */
      66%       { transform: translateX(-200%); }

      /* Imagen 3 pausa */
      66%, 94%  { transform: translateX(-200%); }

      /* Loop suave */
      100%      { transform: translateX(-300%); }
    }
  `}</style>
        </div>

        <div className="bg-[#071F12] p-8 rounded-2xl border border-[#22C55E]/25 flex justify-center" data-id="element-195">
          <div style={{
          width: '260px',
          maxWidth: '85vw',
          overflow: 'hidden'
        }} data-id="element-196">
            <div style={{
            display: 'flex',
            animation: 'slideStep 9s infinite'
          }} data-id="element-197">
              {['https://i.ibb.co/G4VQgy8n/img-0136-4.webp', 'https://i.ibb.co/kV6hmFgt/img-0136-5.webp', 'https://i.ibb.co/r2yM0rjS/img-0136-1-1.webp',
            // duplicado para loop suave
            'https://i.ibb.co/G4VQgy8n/img-0136-4.webp'].map((src, i) => <div key={i} style={{
              flex: '0 0 100%'
            }} data-id="element-198">
                  <img src={src} alt="Testimonio" style={{
                width: '100%',
                height: 'auto',
                borderRadius: '18px',
                display: 'block',
                objectFit: 'cover',
                boxShadow: '0 18px 40px rgba(0,0,0,.5)'
              }} data-id="element-199" />
                </div>)}
            </div>
          </div>

          <style data-id="element-200">{`
    @keyframes slideStep {

      /* Imagen 1 pausa */
      0%, 28%   { transform: translateX(0%); }

      /* Transición */
      33%       { transform: translateX(-100%); }

      /* Imagen 2 pausa */
      33%, 61%  { transform: translateX(-100%); }

      /* Transición */
      66%       { transform: translateX(-200%); }

      /* Imagen 3 pausa */
      66%, 94%  { transform: translateX(-200%); }

      /* Loop suave */
      100%      { transform: translateX(-300%); }
    }
  `}</style>
        </div>
      </div>
    </Section>;
}